/**
 * @file
 * Hides select filters behind a button for mobile.
 */
(function ($, Drupal) {

  'use strict';

  Drupal.advancedSearchCollapse = function(event, $form) {
    if (typeof $form === 'undefined') {
      $form = event.data.form;
    }
    var $container = $form.parents('.views-element-container').first();
    if (window.matchMedia('(max-width: 991px)').matches && $container.hasClass('kas-opened') === false) {
      $form.find('.form-item.panel, button').addClass('hidden');
      $container.find('.advanced-search').css('display', 'block');
    } else if (window.matchMedia('(min-width: 992px)').matches) {
      $form.find('.form-item.panel, button').removeClass('hidden');
      $container.find('.advanced-search').hide();
      $container.removeClass('kas-opened');
    }
  }

  Drupal.behaviors.kinaxisAdvancedSearch = {
    attach: function(context, settings) {
      $('.collapsible-search form').each(function() {
        // open first panel if no one is opened
        var $container = $(this).parents('.views-element-container').first();
        var $firstFilter = $container.find('.resource-search-exposed').find('.form-wrapper').first().find('.panel-title');
        var $collapsedWrapper = $container.find('.resource-search-exposed').find('.form-wrapper').find('.panel-body.in');
        if ($collapsedWrapper.length === 0 && $firstFilter.attr('aria-expanded') === 'false') {
          $firstFilter.click();
        }
        $(window).on('resize', {'form': $(this)}, Drupal.advancedSearchCollapse);
        Drupal.advancedSearchCollapse(null, $(this));
        $('.advanced-search').click(function(e) {
          $(this).siblings().find('.form-item.panel, button').removeClass('hidden');
          $(this).hide();
          $(this).parents('.views-element-container').first().addClass('kas-opened');
          e.preventDefault();
          return false;
        });
      });
      $(document).on({
        ajaxStart: function() {
          $('.view-kinaxis-resources').addClass('loading');
        },
        ajaxStop: function() {
          $('.view-kinaxis-resources').removeClass('loading');
        }
      });

      $(document).on('click', '#edit-field-partner-region-collapsible .js-form-item-field-partner-region-139 #edit-field-partner-region-139', function() {
        if ($(this).is(':checked')) {
          $('#edit-field-partner-region-collapsible :checkbox').prop('checked', true);
        }
      });

      $(document).on('click', '#edit-field-partner-type input[type="checkbox"]', function (){
        var isChecked = $(this).prop('checked');
        var selectedVal = $(this).val();

        $('#edit-field-partner-type-1 input[type="checkbox"]').filter(function() {
          return $(this).val() === selectedVal;
        }).prop('checked', isChecked);
      });
    }
  }

})(jQuery, Drupal);
